<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-dark bg-primary position-fixed start-0 end-0 top-0" v-show="!plExportMode">
    <div class="container-fluid">
      <!-- logo -->
      <div>
        <a class="navbar-brand d-none d-xl-inline cursor-pointer" @click="goToDashboard"><img src="../assets/images/Sinchii_RGB_Logo.png" height="30" tabindex="-1" /></a>
        <a class="navbar-brand d-xl-none cursor-pointer" @click="goToDashboard"><img src="../assets/images/Sinchii_RGB_Logo.png" height="30" tabindex="-1" /></a>
        <k-button class="btn btn-outline-secondary btn-sm me-3 focus" type="button" v-if="businessName && !isAdmin && !adminPage" @click="showOrgSelectScreen" tabindex="-1">{{ businessName }} ▼</k-button>
        <k-button class="btn btn-outline-secondary btn-sm me-3 focus" type="button" v-else-if="businessName && isAdmin && !adminPage" :disabled="true" tabindex="-1">{{ businessName }}</k-button>
        <k-button class="btn btn-secondary btn-sm me-3 focus" type="button" v-if="isImpersonatingUser" @click="impersonateUserLogOut" tabindex="-1">Impersonating User (click to logout)</k-button>
        <k-button class="btn btn-secondary btn-sm me-3 focus" type="button" v-if="trial && isTrial" @click="showSubscriptionModal" tabindex="-1">{{ trialCountdown }}</k-button>
        <k-dropdownbutton v-if="!(isAdmin && !isImpersonatingUser) && !hidePeriodSelect" class="period-select me-3 focus" :text="selectedPeriodText" :items="periodOptions" @itemclick="onPeriodSelect" tabindex="-1"></k-dropdownbutton>
      </div>

        <!-- right menu -->
        <div class="right-nav d-flex" v-if="isLoggedIn">

          <!-- nav main menu -->
          <ul class="navbar-nav main-nav mb-2 mb-lg-0 mt-1" id="mainMenu" :style="{ marginRight: '-1.25rem' }">
            <li class="nav-item" v-for="item in navMenuItems" :key="item.id">
              <a 
                class="nav-link cursor-pointer"
                :class="{'active': $route.path.includes(item.routerPush) || item.alwaysActive, 'disabled': item.disabled}"
                aria-current="page"
                :id="item.id" 
                @click="this.$router.push(item.routerPush)" 
                v-if="isLoggedIn && (!isAdmin || isImpersonatingUser)">
                {{ item.text }}
              </a>
            </li>
            <li class="nav-item" id="whatif">
              <a
                class="btn btn-primary btn-sm me-3"
                :class="{'disabled': selectedPeriod != 'Current'}"
                style="background-color: #00B936"
                aria-current="page"
                id="whatif"
                @click="this.$router.push('/whatIf')" 
                v-if="isLoggedIn && (!isAdmin || isImpersonatingUser)"
                tabindex="-1">
                What If
              </a>
            </li>
          </ul>
          <template v-if="(isAdmin && !isImpersonatingUser)">
            <ul class="navbar-nav main-nav mb-2 mb-lg-0 mt-1" id="mainMenu" :style="{ marginRight: '-1.25rem' }">
            <li class="nav-item" v-for="item in adminNavMenuItems" :key="item.id">
              <a 
                class="nav-link cursor-pointer"
                :class="{'active': $route.path.includes(item.routerPush) || item.alwaysActive, 'disabled': item.disabled}"
                aria-current="page"
                :id="item.id" 
                @click="this.$router.push(item.routerPush)" 
              >
                {{ item.text }}
              </a>
            </li>
          </ul>
          </template>
          <div class="vertical-line mt-2" style="margin-left: 1.5rem; margin-right: 1.0rem;"></div>
          <ul class="navbar-nav mx-auto mb-2 mb-lg-0">
            <!-- thinkific -->
            <li class="nav-item nav-icon" v-if="(!isAdmin || isImpersonatingUser) && this.thinkificLink">
              <a class="nav-link box-shadow rounded-circle cursor-pointer" id="navbarThinkific" data-bs-toggle="help" aria-expanded="false" @click="openThinkific">
                <i class="icon-thinkific"></i>
              </a>
            </li>
            <!-- help -->
            <li class="nav-item nav-icon" v-if="(!isAdmin || isImpersonatingUser) && helpSectionEnabled && this.helpLink">
              <a class="nav-link box-shadow rounded-circle cursor-pointer" id="navbarHelp" data-bs-toggle="help" aria-expanded="false" @click="openHelpLink">
                <i class="icon-help"></i>
              </a>
            </li>
            <!-- toggle dropdown -->
            <li class="nav-item nav-icon dropdown" v-if="(isLoggedIn && (!isAdmin || isImpersonatingUser))">
              <a ref="dropdownButton" class="nav-link box-shadow rounded-circle dropdown-toggle cursor-pointer" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="icon-account"></i>
              </a>
              <ul ref="dropdownMenu" class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                <li><h3 class="cursor-default">Welcome {{loggedInFirstName}},</h3></li>
                <li><a class="dropdown-item cursor-pointer" @click="showMyProfileModal">My Profile</a></li>
                <li><a class="dropdown-item cursor-pointer" @click="showOrgSelectScreen" v-if="!isAdmin">My Organisations</a></li>
                <li><a class="dropdown-item cursor-pointer" @click="showChartOfAccounts">Chart of Accounts</a></li>
                <li><a class="dropdown-item cursor-pointer" @click="showBusinessInfoModal" v-if="isOwner || isAdmin">Business Information</a></li>
                <li><a class="dropdown-item cursor-pointer" @click="goToUsers">Users</a></li>
                <li><a class="dropdown-item cursor-pointer" @click="showSubscriptionModal" v-if="isOwner || isAdmin">Subscription</a></li>
                <li><a class="dropdown-item cursor-pointer" @click="showAccountSecurityModal" v-if="!isXeroUser">Account Security</a></li>
                <li><a class="dropdown-item cursor-pointer" @click="showConnectedAccountsModal" v-if="xeroConnected">Connected Accounts</a></li>
                <li><a class="dropdown-item cursor-pointer" @click="getDebugSpreadsheet" v-if="isImpersonatingUser">Export Diagnostics Info</a></li>
                <li class="dropdown-item cursor-pointer" @click="impersonateUserLogOut" v-if="isImpersonatingUser"> <i class="icon-logout"></i></li>
                <li class="mt-2" v-if="!isImpersonatingUser"><a class="dropdown-item blue-cyan cursor-pointer" @click="logOut">Logout</a></li>
              </ul>
            </li>
            <!-- Grid icon - link to company list page but not use currently atm -->
            <!-- <li class="nav-item nav-icon" v-if="isAdmin">
              <a class="nav-link cursor-pointer" data-bs-toggle="calendar" aria-expanded="false">
                <i class="icon-calendar"></i>
              </a>
            </li> -->
            <!-- log out admin -->
            <li class="nav-item nav-icon" v-if="(isAdmin && !isImpersonatingUser)">
              <a class="nav-link box-shadow rounded-circle dropdown-toggle cursor-pointer" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="icon-account"></i>
              </a>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                <li><h3 class="cursor-default">Welcome {{loggedInFirstName}},</h3></li>
                <li><a class="dropdown-item cursor-pointer" @click="showMyProfileModal">My Profile</a></li>
                <li><a class="dropdown-item cursor-pointer" @click="showAccountSecurityModal" v-if="!isXeroUser">Account Security</a></li>
                <li class="mt-2"><a class="dropdown-item blue-cyan cursor-pointer" @click="logOut">Logout</a></li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <!-- modal collection -->
    <!-- My Profile -->
    <ax-shared-popup
      :size="'md'"
      :id="'modalMyProfile'"
      ref="modalMyProfile"
    >
      <template #body>
        <profile-dialog
          @closePopup="hideMyProfileModal"
        ></profile-dialog>
      </template>
    </ax-shared-popup>

    <!-- Business information -->
    <ax-shared-popup
      :size="'md'"
      :id="'modalBusinessInfo'"
      ref="modalBusinessInfo"
    >
      <template #body>
        <business-info-dialog
          @closePopup="hideBusinessInfoModal"
        ></business-info-dialog>
      </template>
    </ax-shared-popup>

    <!-- account security-->
    <ax-shared-popup
      :size="'md'"
      :id="'modalAccountSecurity'"
      ref="modalAccountSecurity"
    >
      <template #body>
        <account-security-dialog
          :firstSetup="faFirstSetup"
          @click2Fa="hideAccountSecurityModal"
        ></account-security-dialog>
      </template>
    </ax-shared-popup>

    <!-- chart of accounts -->
    <ax-shared-popup
      :size="'xl'"
      :id="'modalChartOfAccounts'"
      ref="modalChartOfAccounts"
    >
      <template #body>
        <chart-of-accounts
          ref="chartOfAccounts"
          :accounts="accounts"
          @closePopup="hideChartOfAccountsModal"
          @hideConfirmationModal="hideConfirmationModal"
          @showConfirmationModal="showConfirmationModal"
          @updateAccounts="updateAccounts"
        />
      </template>
    </ax-shared-popup>

    <!-- connected accounts -->
    <ax-shared-popup
      :size="'md'"
      :id="'modalConnectedAccounts'"
      ref="modalConnectedAccounts"
    >
      <template #body>
        <connected-accounts
          @closePopup="hideConnectedAccountsModal"
          @showXerolog="showXerologModal"
        />
      </template>
    </ax-shared-popup>

    <ax-shared-popup
      :size="'xl'"
        :id="'modalXerolog'"
        ref="modalXerolog"
      >
      <template #body>
        <xerolog-dialog v-if="showXeroLog"
          @closePopup="hideXerologModal()"
        ></xerolog-dialog>
      </template>
    </ax-shared-popup>
  </div>
</template>

<script>
  import Vuex from "vuex";
  import AuthService from "../services/auth-service";
  import SubscriptionService from "../services/subscription-service";
  import ThinkificService from "../services/thinkific-service";
  import HelpService from "../services/help-service";
  import ProfileDialog from "../components/dialogs/ProfileDialog.vue";
  import BusinessInfoDialog from "../components/dialogs/BusinessInfoDialog.vue";
  import AccountSecurity from "../components/dialogs/AccountSecurityDialog.vue";
  import ChartOfAccounts from "../components/dialogs/ChartOfAccounts.vue";
  import ConnectedAccounts from "../components/dialogs/ConnectedAccounts.vue";
  import XeroLogDialog from "../components/dialogs/XeroLogDialog.vue";
  import Help from "../components/dialogs/Help.vue";
  import BusinessService from "../services/business-service";
  import Popup from "../components/Popup.vue";
  import store from '@/store'
  import { useToast } from "vue-toastification";
  const toast = useToast();
  import { createPopper } from "@popperjs/core";

  export default {  
    components: {
      "profile-dialog": ProfileDialog,
      "business-info-dialog": BusinessInfoDialog,
      "account-security-dialog": AccountSecurity,
      "chart-of-accounts": ChartOfAccounts,
      "connected-accounts": ConnectedAccounts,
      "help-dialog": Help,
      "ax-popup": Popup,
      "xerolog-dialog": XeroLogDialog
    },
    props: {
      msg: String
    },
    computed: {
      selectedPeriod() {
        return this.$store.getters.selectedPeriod;
      },
      periodOptions() {
        return [
          { text: "Previous Financial Year", value: "Previous" },
          { text: "Current Financial Year", value: "Current" },
          { text: "Next Financial Year", value: "Next" },
        ].filter(option => option.value !== this.selectedPeriod && (this.hasEndedYear || option.value !== "Previous"));
      },
      navMenuItems() {
        return [
          { id: "dashboard", text: "Dashboard", routerPush: "/dashboard" },
          { id: "cashsummary", text: "Cash Summary", routerPush: "/cashSummary", disabled: this.selectedPeriod != "Current" },
          { id: "profitloss", text: "Profit/Loss", routerPush: "/profitLoss" },
          { id: "incomedrivers", text: "Income Drivers", routerPush: "/incomeDrivers" },
          { id: "expensedrivers", text: "Expense Drivers", routerPush: "/expenseDrivers" },
        ]
      },
      selectedPeriodText() {
        return this.selectedPeriod + ' Financial Year  ▼';
      },
      adminPage() {
        return this.adminNavMenuItems
            .some(item => this.$route.path.toLowerCase().includes(item.routerPush.toLowerCase()));
      },
      hidePeriodSelect() {
        return this.$route.path.includes("/whatIf") || this.$route.path.includes("/cashSummary");
      },
      xeroConnected() {
        return store.getters.organisationType == 1;
      },
      ...Vuex.mapGetters([
        "isLoggedIn",
        "email",
        "isAdmin",
        "isOwner",
        "userID",
        "loggedInFirstName",
        "isSubscribed",
        "isSubscriptionLocked",
        "isSubscriptionCancelled",
        "isTrial",
        "isXeroUser",
        "helpSectionEnabled",
        "plExportMode",
        "organisationType",
        "businessName",
        "isImpersonatingUser"
      ])
    },
    data() {
      return {
        hasEndedYear: false,
        accounts: [],
        trial: false,
        faFirstSetup: false,
        trialCountdown: "",
        defaultHelpTab: "Welcome",
        deleteChartOfAccountContant: {
          title: "Please Confirm",
          description: "Are you sure you want to delete this item?",
          closeBttText: "No",
          confirmBttText: "Yes"
        },
        adminNavMenuItems: [
          { id: "companylist", text: "Company List", routerPush: "/companyList" },
          { id: "affiliateapplication", text: "Affiliate Applications", routerPush: "/affiliateApplication" },
        ],
        showXeroLog: false,
        thinkificLink: null,
        helpLink: null
      }
    },
    async mounted() {
      if (this.isLoggedIn && !this.isAdmin && store.getters.businessID) {
        this.getTrialCountdown();
      }
      
      this.highLightNav();

      ThinkificService.getLink()
        .then(data => {
          this.thinkificLink = data.data.toString();
        });

      HelpService.getLink()
        .then(data => {
          this.helpLink = data.data.toString();
        });

      if (store.getters.businessID && store.getters.isSubscribed) {
        await this.getHasEndedYear();
      }
    },
    watch: {
      "$route.query": {
        handler: function() {
          this.highLightNav();
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      onPeriodSelect(e) {
        this.$store.commit("setSelectedPeriod", e.item.value);
      },
      toggleSettings() {
        var dropdownMenu = document.querySelector('.dropdown-menu');
        if (dropdownMenu) {
          if (dropdownMenu.classList.contains('show')) {
            dropdownMenu.classList.remove('show');
            setTimeout(() => {
              this.showSettings(dropdownMenu);
            }, 100);
          } else {
            this.showSettings(dropdownMenu);
          }
        }
      },
      showSettings(dropdownMenu) {
        dropdownMenu.classList.add('show');

        // listen for click outside the dropdown to close it
        const handleClickOutside = (event) => {
          if (!dropdownMenu.contains(event.target)) {
            dropdownMenu.classList.remove('show');
            document.removeEventListener('click', handleClickOutside);
            window.removeEventListener('resize', handleResize);
          }
        };

        const handleResize = () => {
          dropdownMenu.classList.remove('show');
          document.removeEventListener('click', handleClickOutside);
          window.removeEventListener('resize', handleResize);
        };

        setTimeout(() => {
          document.addEventListener('click', handleClickOutside);
          window.addEventListener('resize', handleResize);
        }, 0);

        // find the distance from the settings menu icon to the bottom of the navbar
        const navbar = document.querySelector('.navbar').getBoundingClientRect();
        const settingsIcon = document.querySelector('.icon-account').getBoundingClientRect();
        const gap = navbar.bottom - settingsIcon.bottom;
        const offset = Math.max(gap, 0) - 8;

        createPopper(this.$refs.dropdownButton, this.$refs.dropdownMenu, {
          placement: "bottom-start",
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, offset],
              },
            },
          ],
        });
      },
      updateAccounts(newList) {
        this.accounts = newList;
      },
      async getAccounts() {
        this.accounts = [];
        await BusinessService.getExpenseAccounts(false, true)
          .then((data) => {
            this.accounts = data.accounts;
          }).catch(this.showAlert);
      },
      async getHasEndedYear() {
        await BusinessService.getHasEndedYear()
          .then((data) => {
              this.hasEndedYear = data.hasEndedYear;
            }).catch(this.showAlert);
      },
      removeAccount() {
        this.$refs.chartOfAccounts.removeAccount();
        this.showChartOfAccounts();
      },
      async getDebugSpreadsheet() {
        var res = await BusinessService.getDebugSpreadsheet();
        this.download(res, "diagnostics.xlsx", "application/xlsx");
      },
      download(data, name, type) {
        const blob = this.b64toBlob(data.data.bytes, type, 512)
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", name);
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 200);
      },
      b64toBlob(b64Data, contentType, sliceSize) {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);

          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
      },
      highLightNav() {
        const navigationLinks = document.querySelectorAll(".nav-link");
        navigationLinks.forEach(link => {
          link.classList.remove("active");
        })
        const element = document.getElementById(String(this.$route.path).toLowerCase().replace("/", ""));
        if (element) {
          element.classList.add("active");
        }
      },
      async logOut() {
        await AuthService.logout();
        this.trial = false;
        this.$router.push("/login");
      },
      async impersonateUserLogOut() {
        await AuthService.impersonateUserLogOut();
        this.$router.push("/companylist");
      },
      showAlert() {
        toast.clear();
        toast.error("An error occurred");
      },
      getTrialCountdown() {
        SubscriptionService.getTrialCountdown()
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .then((endsIn) => {
          if (endsIn) {
            this.trial = true;
            if (endsIn === "1") {
              this.trialCountdown = "Trial ends in " + endsIn + " day";
            } else if (endsIn === "0") {
              this.trialCountdown = "Trial ends in < 1 day";
            } else {
              this.trialCountdown = "Trial ends in " + endsIn + " days";
            }
          } else {
            this.trial = false;
          }
        }).catch(this.showAlert);
      },
      showMyProfileModal() {
        this.$refs.modalMyProfile.open();
      },
      showChartOfAccounts() {
        if (this.accounts.length == 0) {
          this.getAccounts();
        }
        this.$refs.modalChartOfAccounts.open();
      },
      hideMyProfileModal() {
        this.$refs.modalMyProfile.close();
      },
      showBusinessInfoModal() {
        this.$refs.modalBusinessInfo.open();
      },
      hideBusinessInfoModal() {
        this.$refs.modalBusinessInfo.close();
      },
      showXerologModal() {
        this.showXeroLog = true;
        this.$refs.modalXerolog.open();
      },
      hideXerologModal() {
        this.showXeroLog = false;
        this.$refs.modalXerolog.close();
      },
      goToUsers() {
        this.$router.push("/users");
      },
      goToCompanyList() {
        this.$router.push("/companylist");
      },
      showAccountSecurityModal() {
        this.$refs.modalAccountSecurity.open();
      },
      hideAccountSecurityModal() {
        this.$refs.modalAccountSecurity.close();
      },
      showConnectedAccountsModal() {
        this.$refs.modalConnectedAccounts.open();
      },
      hideConnectedAccountsModal() {
        this.$refs.modalConnectedAccounts.close();
      },
      hideChartOfAccountsModal() {
        this.$refs.modalChartOfAccounts.close();
        this.accounts = [];
      },
      openHelpLink() {
        window.location = this.helpLink;
      },
      openThinkific() {
        window.location = this.thinkificLink;
      },
      showSubscriptionModal() {
        this.$root.showSubscriptionModal(store.getters.businessID, false);
      },
      showOrgSelectScreen() {
        this.$root.showOrgSelectScreen();
      }
    }
  }
</script>